import {
    Box,
    Divider,
    List,
    ListItem,
    ListItemText,
    ListSubheader,
} from '@mui/material';
import React from 'react';
import '../style/sidebar.scss';

export const SideBar = ({ selectedTab, setSelectedTab }) => {
    const items = ['List', 'Field-request', 'Add-field', 'Banner'];

    const renderText = (text) => {
        switch (text) {
            case 'List':
                return 'Заалны жагсаалт';
            case 'Field-request':
                return 'Заал нээх хүсэлт';
            case 'Add-field':
                return 'Шинэ заал нээх';
            case 'Banner':
                return 'Banners';
        }
    };

    return (
        <Box className="sidebar">
            <Divider />
            <List
                subheader={
                    <ListSubheader component="div" id="nested-list-subheader">
                        Menu
                    </ListSubheader>
                }
            >
                <Divider />
                {items.map((text) => (
                    <ListItem
                        button
                        key={text}
                        sx={{
                            background:
                                selectedTab === text ? '#1976d2' : 'white',
                        }}
                        onClick={() => setSelectedTab(text)}
                    >
                        <ListItemText
                            primary={renderText(text)}
                            sx={{
                                color: selectedTab === text ? 'white' : 'black',
                            }}
                        />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};
